<template>
  <div class="i-tree">
    <Tree
      ref="tree"
      v-bind="$attrs"
      v-on="$listeners"
      :render="renderContent"
      :data="treeData"
      @on-check-change="getCheckedNodes"
      show-checkbox
    ></Tree>
    <!-- <div style="background:red;">点击</div> -->
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    treeData: {
      type: Array,
      default: () => [
        {
          title: '概览',
          code: 'application-center',
          expand: true,
          children: [
            { title: '公告', code: 'app-tip' },
            { title: '常用应用', code: 'app-normal' },
            {
              title: '资源统计',
              code: 'resource-overview',
              childrens: [
                { title: '查看', code: 'resource-overview' },
                { title: '机时调整', code: 'set-time' },
                { title: '更多资源统计', code: 'more-resource' }
              ]
            }
          ]
        }
      ]
    }
  },
  data() {
    return {}
  },
  watch: {
    value(n) {
      this.defaultTreeData()
    }
  },
  created() {},
  methods: {
    renderContent(h, { root, node, data }) {
      return h(
        'div',
        {
          on: {
            click: () => {}
          },
          style: {
            display: 'flex',
            width: '100%'
          }
        },
        [
          h(
            'span',
            {
              on: {
                click: () => {}
              },
              style: {
                // 'min-width': '40px'
              }
            },
            data.title
          ),
          h(
            'CheckboxGroup',
            {
              props: {
                value: data.codes
              },
              on: {
                'on-change': (val) => {
                  data.codes = val
                  // if (data.childrens.length === val.length) {
                  if (val.length > 0) {
                    this.$set(data, 'checked', true)
                    // this.$set(data, 'selected', true)
                  } else {
                    // data.selected = false
                    // data.checked = false
                  }
                  this.$emit('input', this.getNodes())
                }
              },
              style: {
                marginLeft: '20px',
                display: 'flex',
                'flex-wrap': 'wrap'
              }
            },
            (data.childrens || []).map((item) =>
              h(
                'Checkbox',
                {
                  props: {
                    label: item.code
                  },
                  // 权限关联
                  nativeOn: {
                    change: () => {
                      if (data.codes.includes(item.code)) {
                        this.$emit('change', [item.code,data.code])
                      }
                    }
                  },
                  style: {
                    color: '#2c3542!important',
                    minWidth: '50px'
                  }
                },
                item.title
              )
            )
          )
        ]
      )
    },
    getCheckedNodes(all, data) {
      let selectCode = []
      if (data.checked) {
        data.codes = check(data.children || data.childrens || [])
      } else {
        data.codes = close(data.children || data.childrens || [])
      }
      // 遍历选中复选框
      function check(list) {
        return list.map((item) => {
          if (item.children) item.codes = check(item.children)
          if (item.childrens) item.codes = check(item.childrens)
          return item.code
        })
      }
      // 遍历取消复选框
      function close(list) {
        list.map((item) => {
          if (item.children) item.codes = close(item.children)
          if (item.childrens) item.codes = close(item.childrens)
        })
        return []
      }
      // 权限关联
      if (data.checked) {
        getCodes([data])
        this.$emit('change', [data.code, ...selectCode])
      }
      // 递归获取所有状态码
      function getCodes(list) {
        return list.map((item) => {
          if (item.children) {
            getCodes(item.children)
          }
          if ((item.codes || []).length > 0) {
            selectCode.push(...item.codes)
          }
        })
      }
      this.$emit('input', this.getNodes())
    },
    getNodes() {
      let data = this.$refs.tree.getCheckedAndIndeterminateNodes()
      let params = data.map((item) => item.code)
      data.map((item) => {
        if (item.childrens) {
          params.push(...item.codes)
        }
      })
      return params.filter((item) => item)
    },
    defaultTreeData(data = this.treeData) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].children) {
          this.defaultTreeData(data[i].children)
        }
        if (!data[i].children && this.value.includes(data[i].code)) {
          this.$set(data[i], 'checked', true)
        } else {
          this.$set(data[i], 'checked', false)
          // this.$forceUpdate()
        }
        // 添加子权限码
        let cs = data[i].childrens
        if (cs && cs.length > 0) {
          this.$set(data[i], 'codes', [])
          cs.map((item) => {
            if (this.value.includes(item.code)) {
              data[i].codes.push(item.code)
            }
          })
        } else {
          this.$set(data[i], 'codes', [])
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.i-tree {
  /deep/ .ivu-tree-title {
    width: calc(100% - 30px);
    /*height: 30px;*/
    font-size: 14px;
    font-family: PingFang-SC-Heavy, PingFang-SC;
    color: #2c3542;
    background: transparent;
    > span {
      height: 30px;
      display: inline-flex !important;
      align-items: center;
      justify-content: space-between;
    }

    &:hover {
      background: transparent;
    }
  }
}
</style>
